// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/search-button.js
import BaseComponent from "./base_component"

export default class SearchButton extends BaseComponent {
  static componentName = "search-button"

  constructor(element, config = {}) {
    super(element, config)
    const mac = /Mac|iPhone|iPad/.test(navigator.platform)
    const keys = document.createElement("span")
    keys.className = "search-button-keys"
    keys.setAttribute("aria-hidden", "true")
    for (const label of [mac ? "⌘" : "Ctrl", "/"]) {
      const key = document.createElement("span")
      key.className = "search-button-key"
      key.textContent = label
      keys.append(key)
    }
    element.append(keys)
    this.generated.push(keys)
    element.setAttribute("aria-keyshortcuts", mac ? "Meta+/" : "Control+/")
    this.listen(document, "keydown", (event) => {
      if (
        event.repeat ||
        event.target.closest('input, textarea, select, [contenteditable="true"]') ||
        element.disabled ||
        element.getClientRects().length === 0
      )
        return
      if (event.key === "/" && (mac ? event.metaKey : event.ctrlKey) && !event.altKey) {
        event.preventDefault()
        element.click()
      }
    })
  }
}
